import { Button, type ButtonProps } from "@mui/material"

export const SecurityPrimaryButton = (
  props: Omit<ButtonProps, "variant" | "color" | "sx">,
) => <Button variant="contained" color="primary" sx={{ mb: 6 }} {...props} />
